
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  BaseProfileDataInterface,
  ProfileInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import {
  EmployeeLeavesInterface,
  LeaveRequestInterface,
  LeavesRepositoryInterface,
  UsedLeaveTypesCountsInterface,
} from '@/services/Calendar/leaves/interfaces';
import ViewLeaveRequestDialog from '@/components/dialogs/calendar/leave/ViewLeaveRequestDialog.vue';
import LeaveCountsComponent from '@/views/pages/calendar/leaves/components/LeaveCountsComponent.vue';
import UpcomingLeavesComponent from '@/views/pages/calendar/leaves/components/UpcomingLeavesComponent.vue';
import RecentLeavesComponent from '@/views/pages/calendar/leaves/components/RecentLeavesComponent.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    ViewLeaveRequestDialog,
    LeaveCountsComponent,
    UpcomingLeavesComponent,
    RecentLeavesComponent,
  },
  inject: [
    'profileRepository',
    'leavesRepository',
  ],
})
export default class ViewEmployeeLeaves extends Vue {
  private profileRepository!: ProfileRepositoryInterface;
  private leavesRepository!: LeavesRepositoryInterface;

  private loading: boolean = true;

  private profile!: ProfileInterface;
  private employeeLeaves!: EmployeeLeavesInterface;

  private leaves: LeaveRequestInterface[] = [];
  private usedLeaveTypes: UsedLeaveTypesCountsInterface[] = [];
  private upcomingLeaves: LeaveRequestInterface[] = [];

  private userId: string = this.$route.params.userId;
  private usersMap: { [userId: string]: BaseProfileDataInterface } = {};

  private currentPage: number = 1;
  private totalItems: number = 0;


  public async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.loading = true;
    await this.getProfile();
    await this.getEmployeeLeaves();
    await this.getProfileLeaves();
    await this.getUsersProfileData(this.leaves);
    this.loading = false;
  }

  private async getProfile(): Promise<void> {
    this.profile = await this.profileRepository.getOneByUserId(this.userId);
  }

  private async getEmployeeLeaves(): Promise<void> {
    this.employeeLeaves = await this.leavesRepository.getEmployeeLeaves(this.userId);
  }

  private async getProfileLeaves(): Promise<void> {
    [this.leaves, this.totalItems] = await this.leavesRepository.getAllUserLeaves(this.userId, this.currentPage);
    this.upcomingLeaves = await this.leavesRepository.getUserUpcomingLeaves(this.userId);
    this.usedLeaveTypes = await this.leavesRepository.getUsedLeaveTypesCounts(this.userId);
  }

  private async getUsersProfileData(leaves: LeaveRequestInterface[]): Promise<void> {
    const usersIds: string[] = [];
    leaves.forEach((leave) => {
      if (!usersIds.includes(leave.requestBy)) {
        usersIds.push(leave.requestBy);
      }
      if (!!leave.reviewedBy && !usersIds.includes(leave.reviewedBy)) {
        usersIds.push(leave.reviewedBy);
      }
    });

    const usersProfiles = await this.profileRepository.getBaseProfileDataByUsersIds(usersIds);
    usersProfiles.forEach((profile) => {
      this.usersMap[profile.userId] = profile;
    });
  }

  private async changePage(page: number): Promise<void> {
    this.currentPage = page;
    const [leaves, totalItems] = await this.leavesRepository
      .getAllUserLeaves(this.$store.getters.id, this.currentPage);

    await this.getUsersProfileData(leaves);

    this.leaves = leaves;
    this.totalItems = totalItems;
  }
}
